import React, { useState } from "react";
import styled from "styled-components";
import { ChevronDown, Check } from "lucide-react";
import { Popover, PopoverTrigger, PopoverContent } from "../../shadcn/popover";

const ProductDropdown = ({ value, onValueChange, options }) => {
  const [open, setOpen] = useState(false);
  const selected = options.find((o) => o.value === value);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Trigger type="button">
          <TriggerLabel>{selected?.label || "Select product"}</TriggerLabel>
          <ChevronDown size={16} color="#667085" style={{ flexShrink: 0 }} />
        </Trigger>
      </PopoverTrigger>
      <PopoverContent align="start" className="p-1.5 w-[200px]">
        <List>
          {options.map((opt) => {
            const isSelected = opt.value === value;
            return (
              <Row
                key={opt.value}
                type="button"
                $selected={isSelected}
                onClick={() => {
                  onValueChange(opt.value);
                  setOpen(false);
                }}
              >
                <RowLabel $selected={isSelected}>{opt.label}</RowLabel>
                {isSelected && <Check size={15} color="#7F56D9" style={{ flexShrink: 0 }} />}
              </Row>
            );
          })}
        </List>
      </PopoverContent>
    </Popover>
  );
};

export default ProductDropdown;

const Trigger = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: #ffffff;
  border: 1px solid #E9EAEB;
  border-radius: 8px;
  padding: 8px 12px;
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;

  &:hover {
    border-color: #D6BBFB;
  }

  &:focus-visible {
    outline: none;
    border-color: #7F56D9;
    box-shadow: 0 0 0 3px rgba(127, 86, 217, 0.15);
  }
`;

const TriggerLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #101828;
  white-space: nowrap;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`;

const Row = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  border: none;
  background: ${(p) => (p.$selected ? "#F9F5FF" : "transparent")};
  border-radius: 6px;
  padding: 8px 10px;
  cursor: pointer;
  text-align: left;
  transition: background 0.12s;

  &:hover {
    background: ${(p) => (p.$selected ? "#F9F5FF" : "#F9FAFB")};
  }
`;

const RowLabel = styled.span`
  flex: 1;
  font-size: 13px;
  font-weight: ${(p) => (p.$selected ? "600" : "500")};
  color: ${(p) => (p.$selected ? "#7F56D9" : "#344054")};
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
